<template>
  <div class="ui form">
    <div class="field">
      <label for="">{{ $t("name") }}</label>
      <input type="text" name="name" v-model="setup.name" />
    </div>

    <div class="field">
      <label for="">{{ $t("manufactures") }}</label>
      <div class="field">
        <div class="ui toggle checkbox">
          <input
            type="checkbox"
            name="manufacture_laptop"
            v-model="setup.manufacture_laptop"
          />
          <label>{{ $t("laptop") }}</label>
        </div>
      </div>
      <div class="field">
        <div class="ui toggle checkbox">
          <input
            type="checkbox"
            name="manufacture_desktop"
            v-model="setup.manufacture_desktop"
          />
          <label>{{ $t("desktop") }}</label>
        </div>
      </div>
      <div class="field">
        <div class="ui toggle checkbox">
          <input
            type="checkbox"
            name="manufacture_card"
            v-model="setup.manufacture_card"
          />
          <label>{{ $t("card") }}</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { local_api, error_toast } from "@/utils";
import filters from "@/filters";

export default {
  name: "NvidiaBundleStoreModalGeneral",
  filters: filters,
  components: {},
  computed: {},
  props: { setup: Object },
  data() {
    return {};
  },
  methods: {},
  mounted() {
    // let vm = this;
  },
  watch: {},
  updated: function() {},
};
</script>
